import { combineReducers } from "redux";
import authState from "./auth/reducer";
import graphState from "./graphs/reducer";
import filtersState from "./filters/reducer";
import pageState from "./page/reducer";

export default combineReducers({
  pageState,
  authState,
  graphState,
  filtersState,
});
